import type {
  PerformanceOperationLogCondition,
  PerformanceOperationLogItem,
} from './types'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const performanceOperationLogApi = defineApi(
  'operation',
  ({ prefix }) => {
    /**
     * 绩效操作日志分页列表
     * POST /gobestads/operation/adsPerformance/log/query
     */
    function getOperationLogPage(
      params: PagingRequest<PerformanceOperationLogCondition>,
    ) {
      const pageIndex = params.pageIndex || 1
      const pageSize = params.pageSize || 20

      return requestClient
        .post(prefix('adsPerformance/log/query'), {
          condition: {
            opType: params.condition?.opType,
            quarter: params.condition?.quarter,
            userOpenId: params.condition?.userOpenId,
          },
          pageIndex,
          pageSize,
        })
        .then((res) => {
          return {
            list:
              res.list?.map((item: PerformanceOperationLogItem) => ({
                afterData: item.afterData,
                beforeData: item.beforeData,
                opTime: item.opTime,
                opType: item.opType,
                operatorOpenId: item.operatorOpenId,
                quarter: item.quarter,
                userOpenId: item.userOpenId,
              })) || [],
            total: res.total || 0,
          }
        })
    }

    return {
      getOperationLogPage,
    }
  },
)
